import { useState } from 'react';
import { FormCommentActionBar } from '../FormCommentActionBar';
import { MessageAccessType } from 'app-constants/enums/message';

import styles from './styles.module.scss';
import { Avatar, UserOutlinedIcon } from 'components-antd';
import classNames from 'classnames';

export const CommentReplyBox = ({
  defaultAccessType,
  showAvatar,
  avatarClassName,
  className,
  avatarSrc,
  ...restReplyProps
}: any) => {
  const [commentAccessType, setCommentAccessType] = useState(
    defaultAccessType || MessageAccessType.Everybody,
  );

  return (
    <div className={classNames(styles.replyBox, className)}>
      {showAvatar && (
        <div className={classNames(avatarClassName)}>
          <Avatar src={avatarSrc} size={32} icon={<UserOutlinedIcon />} />
        </div>
      )}

      <FormCommentActionBar
        {...restReplyProps}
        commentAccessType={commentAccessType}
        setCommentAccessType={setCommentAccessType}
      />
    </div>
  );
};
